import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './styles/bootstrap/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.css';
// import BootstrapVue3 from 'bootstrap-vue-3';
// import { createI18n } from 'vue-i18n';
// import en from './locales/en.json';
// import du from './locales/du.json';

import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'jszip';
import 'datatables.net-buttons-bs4';
import 'pdfmake';
import 'datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-buttons/js/buttons.flash';
// import "datatables.net-buttons/js/buttons.html5";
import 'datatables.net-buttons/js/buttons.print';
import posthogPlugin from "./plugins/posthog"; // import the plugin

// const i18n = createI18n({
//     messages: {
//         en: en,
//         du: du
//     },
//     fallbackLocale: 'en',
//     silentFallbackWarn: true
//         // fallbackLocale: ''
// });

const app = createApp(App);
// app.use(i18n);
app.use(router);
app.use(posthogPlugin);
app.mount('#app');
// app.use(BootstrapVue3)

// app.config.globalProperties.$hostName = 'http://94.237.2.122:8080/api';
// app.config.globalProperties.$hostName = 'http://localhost/HR_Engine/api';
// app.config.globalProperties.$hostName = 'http://10.10.20.208/Portal_Engine/api';
app.config.globalProperties.$hostName = 'https://theportal.stratacache-apac.com/api';
